import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./index.css";
import xinaixin from "../../static/images/xinaixin.png";
import xinaixins from "../../static/images/xinaixin-s.png";
import closeimg from "../../static/images/close.png";
import user from "../../static/images/user_new.png";
import { Toast } from "antd-mobile";
import {
  likeQuestion,
  likeAnswer,
  likeOthers,
  getreply,
  getDetail,
} from "../../static/js/http";
import { deXMLFilter } from '../../static/js/utils'
class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailId: props.detailId,
      showModal: props.showModal,
      showInput: props.showInput ? props.showInput : false,
      groupData: props.groupData,
      showLike: props.showLike === false ? props.showLike : true,
      showMore: props.showMore ? props.showMore : false,
      view: props.view ? props.view : false,
      value: "",
      count: 0,
      isAnswerLike: false,
      isQuestionLike: false,
      isReplyLike: false,
      showData: false,
      placeholder: "",
    };
  }
  componentDidMount() {
    this.getDetailData();
    let that = this;
    // 在用户点击其他地方时，关闭弹窗
    window.onclick = function (event) {
      let modal = document.getElementById("myModal");
      if (event.target === modal && that.state.showModal) {
        modal.style.display = "none";
        that.close();
      }
    };
  }
  // 获取详情数据
  getDetailData() {
    let data = {
      questionId: this.state.detailId,
    };
    if (this.state.view) {
      data.view = this.state.view;
    }
    getDetail(data)
      .then((res) => {
        try {
          res.data.answer = deXMLFilter(res.data.answer)
          res.data.question = deXMLFilter(res.data.question)
          if(res.data.replyMany.length > 0) {
            res.data.replyMany.map(item => {
              item.reply = deXMLFilter(item.reply)
            })
          }
        } catch(e) {
          console.error('反转义失败',e)
        }
        let type = 0;
        if (res.data.replyMany.length > 0) {
          type = res.data.replyMany[res.data.replyMany.length - 1].type;
        } else {
          type = 2;
        }
        if (this.state.showMore) {
          res.data.isShowReply = true;
        }
        this.setState({
          detailData: res.data,
          showData: true,
          isQuestionLike: !!res.data.isQuestionLike,
          isAnswerLike: !!res.data.isAnswerLike,
          isReplyLike: !!res.data.isReplyLike,
          placeholder:
            type === 2
              ? `匿名回复（${res.data.alias}）`
              : "解忧人回复后可以再次提问",
        });
      })
      .catch();
  }
  // 给问题点赞或取消赞
  getlikeQuestion() {
    if (this.state.showLike) {
      this.setState(
        {
          isQuestionLike: !this.state.isQuestionLike,
        },
        () => {
          Toast.loading();
          likeQuestion({
            id: this.state.detailId,
          })
            .then((res) => {
              Toast.hide();
              this.getDetailData();
            })
            .catch();
        }
      );
    }
  }
  // 给回答点赞或取消
  getlikeAnswer() {
    if (this.state.showLike) {
      this.setState(
        {
          isAnswerLike: !this.state.isAnswerLike,
        },
        () => {
          Toast.loading();
          likeAnswer({
            id: this.state.detailId,
          })
            .then((res) => {
              Toast.hide();
              this.getDetailData();
            })
            .catch();
        }
      );
    }
  }
  // 给回复点赞或取消
  getlikeOther(item) {
    if (this.state.showLike) {
      item.isReplyLike = !item.isReplyLike;
      Toast.loading();
      likeOthers({
        questionId: this.state.detailId,
        replyId: item.id,
      })
        .then((res) => {
          Toast.hide();
          this.getDetailData();
        })
        .catch();
    }
  }
  input(e) {
    if (e !== "") {
      if (e.target.value !== "") {
        this.setState({
          value: e.target.value,
          count: e.target.value.length,
        });
      }
    }
  }
  // 匿名回复
  getReply() {
    if (this.state.value === "") return;
    Toast.loading("提交中");
    getreply({
      questionId: this.state.detailId,
      reply: this.state.value,
    })
      .then((res) => {
        Toast.info("提交成功", 1);
        Toast.hide();
        this.props.close();
      })
      .catch();
  }
  // 关闭弹窗
  close() {
    this.props.close();
  }
  render() {
    let { detailData, groupData } = this.state;
    return (
      <div id="myModal" className="modal">
        {this.state.showData ? (
          <div className="modal_box">
            <div className="modal_title">
              <span>{detailData && detailData.title}</span>
              <img
                src={closeimg}
                alt=""
                onClick={() => {
                  this.close();
                }}
              />
            </div>
            <div className="modal_bt">
              <p>{detailData && detailData.question}</p>
              {this.state.showLike ? (
                <div
                  className="zan_box zan_box1"
                  onClick={() => {
                    this.getlikeQuestion();
                  }}
                >
                  <img
                    className="zan"
                    src={detailData.isQuestionLike ? xinaixin : xinaixins}
                    alt=""
                  />
                  <span
                    className={
                      detailData.isQuestionLike ? "zan_n active" : "zan_n"
                    }
                  >
                    {detailData && detailData.likeQuestion}
                  </span>
                </div>
              ) : (
                ""
              )}
            </div>
            <div
              className={
                this.state.showInput ? "modal_answer" : "modal_answer mh"
              }
            >
              {/* 解忧人的第一次回答 */}
              <div
                className={
                  this.state.showLike
                    ? "modal_answer_item"
                    : "modal_answer_item modal_answer_item_start"
                }
              >
                <img
                  className="user"
                  src={groupData && groupData.icon}
                  alt=""
                />
                <div className="text">
                  <span>{groupData && groupData.name}</span>
                  <p>{detailData && detailData.answer}</p>
                </div>
                {this.state.showLike ? (
                  <div
                    className="zan_box"
                    onClick={() => {
                      this.getlikeAnswer();
                    }}
                  >
                    <img
                      className="zan"
                      src={detailData.isAnswerLike ? xinaixin : xinaixins}
                      alt=""
                    />
                    <span
                      className={
                        detailData.isAnswerLike ? "zan_n active" : "zan_n"
                      }
                    >
                      {detailData && detailData.likeAnswer}
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {/* 其余回复 */}
              {detailData.isShowReply &&
                detailData &&
                detailData.replyMany &&
                detailData.replyMany.map((item, index) => (
                  <div
                    className={
                      this.state.showLike
                        ? "modal_answer_item"
                        : "modal_answer_item modal_answer_item_start"
                    }
                    key={index}
                  >
                    {item.type === 2 ? (
                      <img
                        className="user"
                        src={groupData && groupData.icon}
                        alt=""
                      />
                    ) : (
                      <img className="user" src={user} alt="" />
                    )}

                    <div className="text">
                      {item.type === 2 ? (
                        <span>{groupData && groupData.name}</span>
                      ) : (
                        <span>{detailData && detailData.alias}</span>
                      )}
                      <p>{item.reply}</p>
                    </div>
                    {this.state.showLike ? (
                      <div
                        className="zan_box"
                        onClick={() => {
                          this.getlikeOther(item);
                        }}
                      >
                        <img
                          className="zan"
                          src={item.isReplyLike ? xinaixin : xinaixins}
                          alt=""
                        />
                        <span
                          className={
                            item.isReplyLike ? "zan_n active" : "zan_n"
                          }
                        >
                          {item.likeReply}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ))}
            </div>
            {this.state.showInput ? (
              <div className="modal_input">
                <div className="box">
                  <textarea
                    disabled={this.state.placeholder.includes("解忧人")}
                    maxLength={500}
                    placeholder={this.state.placeholder}
                    onInput={(e) => {
                      this.input(e);
                    }}
                  ></textarea>
                  <span>{this.state.count}/500</span>
                </div>

                <span
                  className={
                    this.state.value
                      ? "modal_input_btn modal_input_btn_active"
                      : "modal_input_btn"
                  }
                  onClick={() => {
                    this.getReply();
                  }}
                >
                  确定
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default withRouter(Modal);
